import { useLanguage, t } from "../../../i18n";
import React, { useMemo, useState } from "react";
import { Container, Card, Button } from "react-bootstrap";
import { HiOutlineArrowLeft } from "react-icons/hi";
import { useNavigate } from "react-router-dom";
import Sidebar from "../../../components/layout/Sidebar/Sidebar";
import Header from "../../../components/layout/Header/Header";
import MobileOffcanvasNav from "../../../components/layout/MobileOffcanvasNav/MobileOffcanvasNav";
import createRoomListing from "../../../features/listing/services/createRoomListing";
import uploadRoomListingImages from "../../../features/listing/services/uploadRoomListingImages";
import { toast } from "react-toastify";
import ListingForm, { listingInitialValues } from "../../../components/listing/ListingForm/ListingForm";
import ROUTES from "../../../config/routes";
import VerificationNoticeBanner from "../../../components/common/VerificationNoticeBanner/VerificationNoticeBanner";
import Footer from "../../../components/layout/Footer/Footer";
import { useAuth } from "../../../features/auth/context/AuthContext";
import "./CreateListing.css";
import useDocumentTitle from "../../../hooks/useDocumentTitle";
function normalizeUser(user = {}) {
  return {
    ...user,
    id: user?.user_id || user?.id || "",
    user_id: user?.user_id || user?.id || "",
    name: user?.name || user?.full_name || "BaytBuddy User",
    full_name: user?.full_name || user?.name || "BaytBuddy User",
    email: user?.email || "",
    mobile: user?.mobile || "",
    profile_status: user?.profile_status || "",
    nafath_status: user?.nafath_status || ""
  };
}
export default function CreateListing() {
  useLanguage();
  useDocumentTitle("Post a Room");
  const [showMobileNav, setShowMobileNav] = useState(false);
  const navigate = useNavigate();
  const {
    user: authUser
  } = useAuth();
  const user = useMemo(() => normalizeUser(authUser || {}), [authUser]);
  const handleSubmit = async (payload, roomImageFiles, formikHelpers) => {
    try {
      if (formikHelpers?.setSubmitting) {
        formikHelpers.setSubmitting(true);
      }
      const listingResponse = await createRoomListing(payload);
      const createdListingId = listingResponse?.data?.id || listingResponse?.listing?.id || listingResponse?.id;
      if (!createdListingId) {
        throw new Error("Listing created but listing ID was not returned.");
      }
      if (Array.isArray(roomImageFiles) && roomImageFiles.length > 0) {
        await uploadRoomListingImages(createdListingId, {
          images: roomImageFiles
        });
      }
      toast.success(t("Room Listed Successfully"));
      setTimeout(() => {
        navigate(ROUTES.MY_LISTINGS);
      }, 1200);
    } catch (error) {
      console.error("Create listing error:", error);
      toast.error(t(error?.response?.data?.message || error?.message || "Failed to create listing"));
    } finally {
      if (formikHelpers?.setSubmitting) {
        formikHelpers.setSubmitting(false);
      }
    }
  };
  return <div className="bb-dashboard-layout">
      <div className="bb-dashboard-layout__sidebar d-none d-lg-block">
        <Sidebar user={user} />
      </div>

      <div className="bb-dashboard-layout__content">
        <Header onMenuClick={() => setShowMobileNav(true)} />

        <VerificationNoticeBanner user={user} />

        <MobileOffcanvasNav show={showMobileNav} onHide={() => setShowMobileNav(false)} user={user} />


        <main className="bb-create-listing-main">
          <Container fluid>
            <div className="bb-create-listing__back-wrap">
              <Button variant="link" className="bb-create-listing__back-btn" onClick={() => navigate(ROUTES.MY_LISTINGS)}>

                <HiOutlineArrowLeft className="me-2" />{t("Back to My Posts")}

              </Button>
            </div>

            <div className="bb-create-listing-hero">
              <div>
                <h1 className="bb-create-listing-hero__title">{t("Post a Room")}</h1>
                <p className="bb-create-listing-hero__subtitle">{t("Add complete room details so the right users can discover your listing.")}


                </p>
              </div>
            </div>

            <Card className="bb-create-listing-card">
              <Card.Body>
                <ListingForm initialValues={listingInitialValues} submitLabel={t("Post Room")} onSubmit={handleSubmit} onCancel={() => navigate(ROUTES.MY_LISTINGS)} />

              </Card.Body>
            </Card>
          </Container>
        </main>

        <Footer />
      </div>
    </div>;
}
